import { commonRequestData, fetchData } from "../../api";

/**
 * @description Obtiene todos los eventos de agenda de los vendedores según los criterios especificados.
 * 
 * @param {Object} params - Parámetros para filtrar los eventos
 * @param {string} params.estado_agenda - Estado de los eventos de agenda a consultar (ej. 'pendiente', 'completado', 'cancelado')
 * @param {string} params.fecha_inicio - Fecha de inicio del rango para filtrar eventos (formato YYYY-MM-DD)
 * @param {string} params.fecha_fin - Fecha de fin del rango para filtrar eventos (formato YYYY-MM-DD)
 * @param {number|string} params.id_admin_agenda - Identificador del administrador de agenda
 * 
 * @returns {Promise<Object>} Promesa que resuelve con los datos de eventos recuperados del servidor
 * 
 * @example
 * // Ejemplo de uso
 * const eventos = await traerEventosTodosVendedores({
 *   estado_agenda: 'pendiente',
 *   fecha_inicio: '2025-06-01',
 *   fecha_fin: '2025-06-30',
 *   id_admin_agenda: 123
 * });
 */
export const traerEventosTodosVendedores = async ({ estado_agenda, fecha_inicio, fecha_fin, id_admin_agenda }) => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
        estado_agenda,
        fecha_inicio,
        fecha_fin,
        id_admin_agenda
    };

    // Solicita la lista de eventos de todos los vendedores usando el endpoint "traerEventosTodosVendedores".
    const response = await fetchData("traerEventosTodosVendedores", requestData);

    // Retorna la respuesta de la API.
    return response;
};


/**
 * @description Crea un nuevo evento en la agenda utilizando los datos proporcionados.
 * 
 * @param {Object} params - Parámetros para crear el evento
 * @param {Object} params.formData - Datos del formulario con la información del evento
 * @param {string} params.formData.titulo - Título del evento
 * @param {string} params.formData.fecha - Fecha del evento (formato YYYY-MM-DD)
 * @param {string} params.formData.hora - Hora del evento (formato HH:MM)
 * @param {string} params.formData.descripcion - Descripción del evento
 * @param {number|string} params.formData.id_cliente - ID del cliente relacionado
 * @param {number|string} params.id_admin_agenda - Identificador del administrador que crea el evento
 * 
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta del servidor tras crear el evento
 * 
 * @example
 * // Ejemplo de uso
 * const resultado = await crearNuevaAgenda({
 *   formData: {
 *     titulo: 'Reunión con cliente',
 *     fecha: '2025-06-15',
 *     hora: '14:30',
 *     descripcion: 'Presentación de propuesta',
 *     id_cliente: 123
 *   },
 *   id_admin_agenda: 456
 * });
 */
export const crearNuevaAgenda = async ({ formData, id_admin_agenda }) => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
        formData,
        id_admin_agenda
    };

    // Envía los datos para crear un nuevo evento de agenda
    const response = await fetchData("crearNuevaAgenda", requestData);

    // Retorna la respuesta de la API.
    return response;
};


export const traerEventosTodosPersonalApi = async ({ estado_agenda, fecha_inicio, fecha_fin, id_admin_agenda }) => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
        estado_agenda,
        fecha_inicio,
        fecha_fin,
        id_admin_agenda
    };

    // Solicita la lista de eventos de todos los vendedores usando el endpoint "traerEventosTodosVendedores".
    const response = await fetchData("traerEventosTodosPersonal", requestData);

    // Retorna la respuesta de la API.
    return response;
};




export const extraerEventoIdApi = async ({ id_agenda }) => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
        id_agenda
    };

    // Solicita la lista de eventos de todos los vendedores usando el endpoint "traerEventosTodosVendedores".
    const response = await fetchData("extraerEventoId", requestData);

    // Retorna la respuesta de la API.
    return response;
};


export const actualizarAgendaApi = async ({ formData, id_admin_agenda }) => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
        formData,
        id_admin_agenda
    };

    // Envía los datos para crear un nuevo evento de agenda
    const response = await fetchData("editarAgenda", requestData);

    // Retorna la respuesta de la API.
    return response;
};